import { parseTipoCertificado } from 'components/UsuarioGeneral/Solicitud Certificados/Solicitud_Certificados';
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
//Componentes
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, FormGroup, Label, Container, Input } from "reactstrap";
import { DatosVistaPrevia, PersonalFirmaCertificado } from './AnalistaAdministraSolicitudesCertificados';
import SelectItem from "components/Varios/select";
import { alertService } from 'components/Varios/alert_service';
import axios from 'axios';
//url
import configData from "../../../config.json";
import { authenticationService } from 'services/authentication.service';
import { UserData } from 'components/Sidebar/Sidebar_Principal';


type ModalVistaPreviaProps = {
    show: boolean,
    toogle: () => void,
    onClose: () => void,
    datos: {
        url: string,
        ids: DatosVistaPrevia,
    }
    // opcionesFirma: { value: string, label: string }[]
    // opcionFirma: number,
    handleSelectChange: (value: string, name: string) => void
    handleActualizarVistaPrevia: () => void

    handleEncabezadoDirigido: (valor: string) => void
    handleGenerarCertificado: () => void
}



export default function ModalVistaPrevia(props: ModalVistaPreviaProps) {


    const [encabezadoDirigido, setencabezadoDirigido] = useState<string>("");
    const [buttonActualizarVistaPrevia, setbuttonActualizarVistaPrevia] = useState<HTMLElement | undefined>(undefined)
    useEffect(() => {
        if (props.datos.ids.dirigido) {
            var persona_dirigida = props.datos.ids.dirigido
            var texto_encabezado = `Señor(a)/Señores(as)\n${persona_dirigida}\nEn su despacho.-`;
            setencabezadoDirigido(texto_encabezado);
            if (typeof props.handleEncabezadoDirigido === 'function') {
                props.handleEncabezadoDirigido(texto_encabezado);
            }
        }
        else {
            setencabezadoDirigido("")
        }



    }, [props.datos.ids.dirigido])

    useEffect(() => {
        if (encabezadoDirigido !== "" && props.datos.ids.tieneDirigido) {
            var elemento: any = (
                <div className='container_actualizacion_vp text-align-right'>
                    <Button className="btn btn-secondary btnActualizarVPCert" onClick={() => props.handleActualizarVistaPrevia()}>Actualizar Vista Previa Certificado</Button>
                    <small>Si quieres ver reflejados tus cambios, puedes dar click en el botón</small>
                </div>
            )
            setbuttonActualizarVistaPrevia(elemento);
        }
    }, [encabezadoDirigido])





    function handleChangeEncabezado(valor: string) {
        setencabezadoDirigido(valor);
        if (typeof props.handleEncabezadoDirigido === 'function') {
            props.handleEncabezadoDirigido(valor);
        }
    }

    function CloseModal(){
        props.onClose()
        document.body.classList.remove('modal-open')

    }

    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={"xl"}
            fullscreen={"xl"}
            centered={false}
            onClosed={() => CloseModal()}
            contentClassName="custom-modal-style"
        >
            <ModalHeader
                close={<i onClick={() => props.toogle()} className="fa-solid fa-xmark" />}
            >
                {parseTipoCertificado(props.datos.ids.idtipocertificado)}
            </ModalHeader>
            <ModalBody className="modalBodyVPEmisionCert">
                {
                    props.datos.url !== "" &&
                    <div className="containerPdfCertificadoVP" >
                        <object data={props.datos.url + "#zoom=80"}
                            type="application/pdf"
                            className= { (encabezadoDirigido || props.datos.ids.tieneDirigido) ?'container-pdf-dirigido':'container-pdf'}

                        >

                        </object>
                    </div>
                }

                <form>
                    {
                        <React.Fragment>

                            {(encabezadoDirigido || props.datos.ids.tieneDirigido) &&
                                <Row form className="align-items-center">
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="tipocertificadoselect">Indique formato de persona dirigida </Label>
                                            <Input
                                                type="textarea"
                                                cols={6}
                                                rows={5}
                                                value={encabezadoDirigido}
                                                onChange={(e) => handleChangeEncabezado(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <div   className="containerDatosEmitirCertificado"></div>
                                        <FormGroup>
                                            {buttonActualizarVistaPrevia}
                                        </FormGroup>
                                    </Col>
                                </Row>

                            }




                        </React.Fragment>
                    }

                </form>



            </ModalBody>
            <ModalFooter>

                {
                    ((props.datos.ids.tieneDirigido && encabezadoDirigido !== "") || (!props.datos.ids.tieneDirigido)
                    )
                    &&
                    <Button onClick={() => props.handleGenerarCertificado()}>Generar y Enviar a firmar Certificado</Button>
                }
                <button className="btn btn-secondary" onClick={() => props.toogle()}>
                    Cerrar
                </button>
            </ModalFooter>
        </Modal>
    )
}
